var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toolbar',[_c('h2',[_c('i',{staticClass:"fa fa-users"}),_vm._v(" Employees")]),_c('div',{staticClass:"controls"},[_vm._t("default"),_c('nav-tabs',{attrs:{"tabs":_vm.tabs}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }